import { createContext } from 'react';
export const FeatureFlagsContext = createContext({
  loading: true
});